var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=Muli:400,600&display=swap","rel":"stylesheet"}}),_c('HelloWorld')],1)}
var staticRenderFns = []

export { render, staticRenderFns }